import {
  Box,
  Icon,
  InputGroup,
  InputRightElement,
  Placement,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react'
import { Token } from '@chakra-ui/styled-system/dist/types/utils'
import * as CSS from 'csstype'
import React from 'react'
import { GoCalendar } from 'react-icons/go'
import '../../../node_modules/@blueprintjs/core/lib/css/blueprint.css'
import '../../../node_modules/@blueprintjs/datetime/lib/css/blueprint-datetime.css'
import DatePicker from '../DatePicker/DatePicker'
import { Input } from '../Forms'
import isDateFormat from './utils/isDateFormat'
import isDateValid from './utils/isDateValid'

interface DatePickerInputProps {
  showActionsBar?: boolean
  shortcuts?: boolean
  onChange: (date: Date | string) => void
  placement?: Placement
  date: Date | string
  maxDate?: Date
  minDate?: Date
  disableFutureDates?: boolean
  disablePastDates?: boolean
  isInvalid?: boolean
  highlightCurrentDay?: boolean
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void
  width?: Token<CSS.Property.Width | number, 'sizes'>
}

const DatePickerInput = ({
  showActionsBar = true,
  shortcuts = false,
  placement = 'top',
  date,
  disableFutureDates = false,
  maxDate,
  disablePastDates = false,
  minDate,
  isInvalid = false,
  onBlur,
  onChange,
  highlightCurrentDay = true,
  width,
}: DatePickerInputProps) => {
  const validDate = isDateValid(date)
  const validDateFormat = isDateFormat(date)
  return (
    <Box>
      <Popover placement={placement}>
        <PopoverTrigger>
          <InputGroup>
            <Input
              width={width}
              placeholder="MM/DD/YYYY"
              value={
                validDate && validDateFormat
                  ? new Date(date).toLocaleDateString('en-US', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    })
                  : `${date || ''}`
              }
              onChange={e => onChange(e.target.value)}
              onBlur={onBlur}
              isInvalid={
                isInvalid ||
                !!((date && !validDate) || (date && !validDateFormat))
              }
            />
            <InputRightElement>
              <Icon as={GoCalendar} color="gray.600" w="1.2em" h="1.2em" />
            </InputRightElement>
          </InputGroup>
        </PopoverTrigger>
        <PopoverContent w="auto" _focus={{ outline: 'none' }}>
          <PopoverArrow />
          <DatePicker
            date={validDate && validDateFormat ? new Date(date) : null}
            onChange={onChange}
            showActionsBar={showActionsBar}
            shortcuts={shortcuts}
            disableFutureDates={disableFutureDates}
            disablePastDates={disablePastDates}
            highlightCurrentDay={highlightCurrentDay}
            maxDate={maxDate}
            minDate={minDate}
          />
        </PopoverContent>
      </Popover>
    </Box>
  )
}

export default DatePickerInput
